export enum CeleryTaskStatesEnum {
  PENDING = "PENDING",
  STARTED = "STARTED",
  RETRY = "RETRY",
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS"
}
